import {injectable} from 'inversify';

import type {CurrencyModel} from '../Currency/Currency.model';

import {PriceModel} from './Price.model';

@injectable()
export class PriceFactory {
  create(amount: number, currency?: CurrencyModel): PriceModel {
    return new PriceModel(amount, currency);
  }
}
